import {DeleteOutlined} from '@ant-design/icons';
import {Button, Modal, Space} from 'antd';
import {Document, useDeleteDocumentMutation} from 'api/generated';
import {documentsQuery} from 'api/queries';
import {useAccessLevel} from 'hooks/useAccessLevel';
import {getDocumentName} from 'lib/documentUtils';
import React from 'react';
import {useParams} from 'react-router-dom';
import {DownloadDocument} from 'routes/Account/Document/DownloadDocument';

const {confirm} = Modal;

type Props = {
  document: Document;
};

export const DocumentActions: React.FC<Props> = ({document}) => {
  const {accountId} = useParams<{accountId: string}>();
  const {isAdmin} = useAccessLevel();

  const [deleteDocument] = useDeleteDocumentMutation();

  if (!isAdmin) return null;

  const handleDelete = () => {
    confirm({
      title: 'Are you sure?',
      okText: 'Delete document',
      okType: 'danger',
      content: (
        <>
          This action will completely delete document <b>{getDocumentName(document)}</b>.
        </>
      ),
      onOk: () => {
        return deleteDocument({
          variables: {id: document.id, accountId},
          mapResultToUpdate: () => document,
          updateQuery: {query: documentsQuery, variables: {accountId}}
        });
      }
    });
  };

  return (
    <Space>
      <DownloadDocument document={document} size="small" />
      <Button size="small" danger onClick={() => handleDelete()} icon={<DeleteOutlined />} />
    </Space>
  );
};
